<template>
  <div class="p-2 bg-gray-100 w-full">
    <div class="grid grid-cols-9 gap-2">
      <div class="p-2 text-gray-300">
        {{ type }}
      </div>
      <div class="p-2 text-gray-400">
        {{ createdAtDisplay }}
      </div>
      <div class="p-2 text-gray-400">
        {{ completedAtDisplay }}
      </div>
      <div class="col-span-2 p-2 font-bold">
        {{ status }}
      </div>
      <div class="p-2 font-bold text-gray-400">
        {{ dateDisplay }}
      </div>
      <div class="flex flex-col p-2 text-gray-600">
        <ul class="list-disc">
          <li class="font-italic text-sm"
            v-for="partition of partitions"
            :key="partition">
            {{ partition }}
          </li>
        </ul>
      </div>
      <div class="col-span-2 p-2 font-italic text-gray-400">
        {{ options }}
      </div>
    </div>
  </div>
</template>

<script>
import user from '../../../services/user/user.js'
import partitions from '../../../services/partitions.js'

export default {
  components: {
    //
  },
  props: {
    routePullEntry: Object,
  },
  data() {
    return {
      partitionIds: this.routePullEntry.args[1],
      allPartitions: undefined,
    }
  },
  methods: {
    async setAllPartitionsFromService() {
      this.$set(this, 'allPartitions', await partitions.getPartition())
    }
  },
  computed: {
    createdAtDisplay() {
      return new Date(this.routePullEntry.created_at).toLocaleString(
        'en-US',
        {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        }
      )
    },
    completedAtDisplay() {
      if (!this.routePullEntry.completed_at) {
        return '---'
      }

      return new Date(this.routePullEntry.completed_at).toLocaleString(
        'en-US',
        {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        }
      )
    },
    type() {
      return this.routePullEntry.type
    },
    status() {
      return this.routePullEntry.status
    },
    dateDisplay() {
      return this.routePullEntry.date
    },
    partitions() {
      if (this.allPartitions === undefined) {
        return this.partitionIds
      }

      return this.partitionIds.map(
        partitionId => (partitions.getPartitionSync(partitionId)).description
      )
    },
    options() {
      return JSON.stringify(this.routePullEntry.kwargs.options, undefined, 2)
    },
  },
  async mounted() {
    await user.ready()
    await this.setAllPartitionsFromService()
  },
  watch: {
    routePullEntry() {
      this.setAllPartitionsFromService()
    },
  },
}
</script>
